export default "__VITE_ASSET__C8Xijuut__"